export default {
    registration: 'EnРегистрация',
};